import React from 'react';
import { Modal, Button } from 'antd';

interface ModalComponentProps {
    title: string;
    visible: boolean;
    okButtonText: string;
    cancelButtonText?: string;
    onOk: () => void;
    onCancel?: () => void;
    isCancelButtonShown?: boolean;
    isClosable?: boolean;
    description?: string;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
    title,
    visible,
    okButtonText,
    cancelButtonText,
    onOk,
    onCancel,
    isCancelButtonShown = false,
    isClosable = true,
    description,
}) => {
    return (
        <Modal
            title={title}
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
            closable={isClosable}
            footer={[
                <>
                    {isCancelButtonShown &&
                        <Button key="submit" type="primary" onClick={onCancel}>
                            {cancelButtonText}
                        </Button>}
                    <Button key="submit" type="primary" onClick={onOk}>
                        {okButtonText}
                    </Button>
                </>
            ]}>
            <p>{description}</p>
        </Modal>
    );
};

export default ModalComponent;